import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import KingBedIcon from '@mui/icons-material/KingBed';
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RouteIcon from '@mui/icons-material/Route';
import TourIcon from '@mui/icons-material/Tour';
import { ItemType } from 'antd/es/menu/interface';
import { renderSidebarLabel } from 'layouts/MainLayout/helper';
import { PEAK_SEASON_CONFIG_TYPE } from 'modules/Configuration/PeakSeasonConfigPage/constants';
import React from 'react';
import { getPath } from 'routes/router-paths';
import { MODULE_TYPE, REGION } from 'utils/constants';

export const hotelMenuItems: ItemType[] = [
  {
    key: 'Khách sạn',
    label: 'Khách sạn',
    type: 'group',
    children: [
      {
        key: getPath('hotelListPage'),
        label: renderSidebarLabel('Danh sách khách sạn'),
        icon: <KingBedIcon />,
      },
      {
        key: getPath('hotelBookingReportPage'),
        label: renderSidebarLabel('Báo cáo booking'),
        icon: <ReceiptLongIcon />,
      },
    ],
  },
  {
    key: 'Cấu hình',
    label: 'Cấu hình',
    type: 'group',
    children: [
      {
        key: getPath(
          'peakSeasonConfigPage',
          MODULE_TYPE.HOTEL,
          PEAK_SEASON_CONFIG_TYPE.PEAK_SEASON
        ),
        label: renderSidebarLabel('Cao điểm bán'),
        icon: <PermDataSettingIcon />,
      },
    ],
  },
];

export const tourMenuItems: ItemType[] = [
  {
    key: 'Tour',
    label: 'Tour',
    type: 'group',
    children: [
      {
        key: getPath('tourRouteManagementPage', REGION.DOMESTIC),
        label: renderSidebarLabel('Quản lý tuyến tour'),
        icon: <RouteIcon />,
      },
      {
        key: getPath('tourListPage', REGION.DOMESTIC),
        label: renderSidebarLabel('Danh sách tour'),
        icon: <TourIcon />,
      },
      {
        key: getPath('tourBookingListPage'),
        label: renderSidebarLabel('Quản lý booking'),
        icon: <CollectionsBookmarkIcon />,
      },
      {
        key: 'Báo cáo booking',
        label: renderSidebarLabel('Báo cáo booking'),
        icon: <ReceiptLongIcon />,
      },
    ],
  },
  {
    key: 'Cấu hình',
    label: 'Cấu hình',
    type: 'group',
    children: [
      {
        key: getPath(
          'peakSeasonConfigPage',
          MODULE_TYPE.TOUR,
          PEAK_SEASON_CONFIG_TYPE.PEAK_SEASON
        ),
        label: renderSidebarLabel('Cao điểm bán'),
        icon: <PermDataSettingIcon />,
      },
    ],
  },
];

export const amusementTicketMenuItems: ItemType[] = [
  {
    key: 'Vé vui chơi',
    label: 'Vé vui chơi',
    type: 'group',
    children: [
      {
        key: getPath('amusementListPage'),
        label: renderSidebarLabel('Danh sách khu vui chơi'),
        icon: <RouteIcon />,
      },
    ],
  },
  {
    key: 'Cấu hình',
    label: 'Cấu hình',
    type: 'group',
    children: [
      {
        key: getPath(
          'peakSeasonConfigPage',
          MODULE_TYPE.AMUSEMENT_TICKETS,
          PEAK_SEASON_CONFIG_TYPE.PEAK_SEASON
        ),
        label: renderSidebarLabel('Cao điểm bán'),
        icon: <PermDataSettingIcon />,
      },
    ],
  },
];
